import type { Release } from '../releases';

export default {
  id: '2026-11-04-offline-wipe',
  at: '2026-11-04T10:23:00Z',
  title: 'Выход из портала стирает данные площадки на телефоне',
  modules: ['site'],
  items: [
    'После «Выйти», переключения компании или окончания сеанса портал стирает на телефоне то, что запомнил для работы без связи: план дня, листы ПСД и отметки «Взять на вахту».',
    'Неотправленные отчёты, замечания и приёмки не пропадают: они уйдут, когда тот же человек снова войдёт.',
  ],
  why: 'Телефон на площадке часто переходит из рук в руки. Следующий человек или та же учётная запись в другой компании не должны видеть чужие планы и чертежи.',
  link: '/site/day',
} satisfies Release;
